module.exports = __webpack_public_path__ + "static/media/1.d097d1ae.jpg";